import React from 'react';

import { LayoutContextProvider } from './layout';

const GlobalContext = ({ children }) => {
    return (
        <>
            <LayoutContextProvider>
                { children }
            </LayoutContextProvider>
        </>
    )
}

export default GlobalContext;
